import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
  APP_INITIALIZER
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideNzI18n, pt_BR } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import pt from '@angular/common/locales/pt';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { loadingInterceptor } from './core/loading/interceptors/loading.interceptor';
import { i18nInitializer } from './core/i18n/i18n.initializer';
import { errorInterceptor } from './core/alerts/interceptors/error.interceptors';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { icons } from './core/icons/icons-provider';
import { provideNzConfig } from 'ng-zorro-antd/core/config';
import { acessoInterceptor } from './core/acesso/acesso.interceptor';
import { NzModalModule } from 'ng-zorro-antd/modal';

registerLocaleData(pt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideNzI18n(pt_BR),
    provideNzIcons(icons),
    provideNzConfig({
      theme: {
        primaryColor: '#019edd'
      }
    }),
    importProvidersFrom(FormsModule, NzModalModule),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([
        loadingInterceptor,
        errorInterceptor,
        acessoInterceptor
      ])
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: i18nInitializer,
      multi: true
    }
  ]
};